import React, { Component } from 'react';
import HeroSectionStyle from './HeroSectionStyle';
import { Link } from 'react-router-dom';

import Fade from 'react-reveal/Fade';

import heroImage from '../../img/heroImage.svg'

class HeroSection extends Component {
    render() {
        return (
            <div className="heroSection">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6">
                            <p className="text-white heroSection-heading">
                                Hello, I'm <span>Nishant Arora</span>
                            </p>
                            <p className="heroSection-content">Hi there! I am a Fullstack developer specialized in React
                                and Node.js. I've always had a passion for technology and product development. I use my
                                experience to be more than just a coder, connecting business requirements with modern
                                technology. I have 3+ years of development experience building fullstack products from
                                scratch, developing and integrating APIs, working with a variety of databases and clould
                                platforms.
                            </p>
                            <div className="heroSection-border"/>
                            <p className="heroSection-content pt-5">Selected projects below, or check out some</p>
                            <Link to="/Process">
                                <button className="HeroBtn btn"><span className="text-white">Behind the scenes</span></button>
                            </Link>
                        </div>
                        <div className="col-12 col-lg-6">
                            <Fade top>
                                <img className="img-fluid" src={heroImage} alt="heroImage"/>
                            </Fade>
                        </div>
                    </div>
                </div>
                <HeroSectionStyle />
            </div>
        );
    }
}

export default HeroSection;
